import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/core/data/query-client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { AppShell } from "@/layout/app-shell";
import { ProtectedLayout } from "@/layout/protected-layout";
import LoginPage from "./pages/login";
import {  InformationSynthesisPage } from "./pages/app-pages";
import { KnowledgeBasesPage } from "./pages/knowledge-bases";
import { KnowledgeBaseDetailPage } from "./pages/knowledge-base-detail";
import { SharePointOAuthCallbackPage } from "./pages/knowledge-base-detail/presentation/sharepoint-oauth-callback-page";
import { useAuth } from "@/core/auth/auth-context";
import { AuthLoadingFallback } from "./core/auth/auth-loading-fallback";
import { navPaths } from "./core/constants";

const LoginRoute = () => {
  const { status } = useAuth();
  if (status === "loading") {
    return <AuthLoadingFallback />;
  }
  if (status === "authenticated") {
    return <Navigate to={navPaths.knowledgeBases} replace />;
  }
  return <LoginPage />;
};

const RootRedirect = () => {
  const { status } = useAuth();
  if (status === "loading") {
    return <AuthLoadingFallback />;
  }
  if (status === "authenticated") {
    return <Navigate to={navPaths.knowledgeBases} replace />;
  }
  return <Navigate to={navPaths.login} replace />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path={navPaths.login} element={<LoginRoute />} />
      <Route path="/oauth-callback" element={<SharePointOAuthCallbackPage />} />
      <Route element={<ProtectedLayout />}>
        <Route element={<AppShell />}>
          {/* <Route path={navPaths.home} element={<HomePage />} /> */}
          <Route path={navPaths.knowledgeBases} element={<KnowledgeBasesPage />} />
          <Route
            path={navPaths.knowledgeBaseDetail}
            element={<KnowledgeBaseDetailPage />}
          />
          <Route
            path={navPaths.knowledgeBaseDocument}
            element={<KnowledgeBaseDetailPage />}
          />
          <Route
            path={navPaths.infoSynthesis}
            element={<InformationSynthesisPage />}
          />
          <Route
            path={navPaths.infoSynthesisSession}
            element={<InformationSynthesisPage />}
          />
        </Route>
      </Route>
      <Route path="/" element={<RootRedirect />} />
      <Route path="*" element={<Navigate to={navPaths.knowledgeBases} replace />} />
    </Routes>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster />
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
